import React, { useState } from "react";
import { Form, Button, Icon } from "semantic-ui-react";
import { map } from "lodash";
import { useExtraGroup } from "../../../../hooks";
import "./AddEditExtraGroupForm.scss";

export function AddEditExtraGroupForm(props) {
  const { onClose, onRefetch, extraGroup } = props;
  const { addExtraGroup, updateExtraGroup } = useExtraGroup();
  const [label, setLabel] = useState(extraGroup?.label || "");
  const [order, setOrder] = useState(extraGroup?.order ?? 0);
  const [items, setItems] = useState(
    extraGroup?.items?.length
      ? extraGroup.items.map((item) => ({
          ...item,
          estimated_cost: item.estimated_cost ?? "",
        }))
      : [{ label: "", price: "", estimated_cost: "" }]
  );

  const updateItem = (index, field, value) => {
    setItems((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    );
  };

  const addItemRow = () => {
    setItems((prev) => [...prev, { label: "", price: "", estimated_cost: "" }]);
  };

  const removeItemRow = (index) => {
    setItems((prev) => prev.filter((_, i) => i !== index));
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    const data = {
      label,
      order: Number(order) || 0,
      items: items
        .filter((item) => item.label.trim() && item.price !== "")
        .map((item, index) => ({
          label: item.label,
          price: item.price,
          estimated_cost: item.estimated_cost === "" ? null : item.estimated_cost,
          order: index,
        })),
    };

    if (extraGroup) await updateExtraGroup(extraGroup.id, data);
    else await addExtraGroup(data);

    onRefetch();
    onClose();
  };

  return (
    <Form className="add-edit-extra-group-form" onSubmit={onSubmit}>
      <Form.Input
        label="Nombre del grupo"
        placeholder="Ej. Vegetales Opcionales"
        value={label}
        onChange={(_, data) => setLabel(data.value)}
      />
      <Form.Input
        type="number"
        label="Orden de aparición"
        placeholder="0"
        value={order}
        onChange={(_, data) => setOrder(data.value)}
      />

      <label className="add-edit-extra-group-form__items-label">Items</label>

      {items.length > 0 && (
        <div className="add-edit-extra-group-form__item-headers">
          <span>Nombre</span>
          <span>Precio</span>
          <span>Costo estimado</span>
        </div>
      )}

      {map(items, (item, index) => (
        <div className="add-edit-extra-group-form__item" key={index}>
          <Form.Input
            placeholder="Nombre (ej. Brocoli)"
            value={item.label}
            onChange={(_, data) => updateItem(index, "label", data.value)}
          />
          <Form.Input
            type="number"
            placeholder="Precio"
            value={item.price}
            onChange={(_, data) => updateItem(index, "price", data.value)}
          />
          <Form.Input
            type="number"
            placeholder="Costo (opcional)"
            value={item.estimated_cost}
            onChange={(_, data) => updateItem(index, "estimated_cost", data.value)}
          />
          <Button
            type="button"
            icon
            negative
            basic
            onClick={() => removeItemRow(index)}
          >
            <Icon name="close" />
          </Button>
        </div>
      ))}

      <Button type="button" basic fluid onClick={addItemRow}>
        <Icon name="plus" /> Agregar item
      </Button>

      <Button
        type="submit"
        primary
        fluid
        content={extraGroup ? "Actualizar" : "Crear"}
      />
    </Form>
  );
}
